import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DevExtremeModule} from '../devextreme.module';
import {SkewSentimentIndicatorComponent} from './skew-sentiment-indicator.component';
import {SkewSentimentService} from './skew-sentiment.service';

@NgModule({
    imports: [
        CommonModule,
        DevExtremeModule,
    ],
    exports: [
        SkewSentimentIndicatorComponent
    ],
    declarations: [
        SkewSentimentIndicatorComponent
    ],
    providers: [
        SkewSentimentService
    ]
})
export class SkewSentimentIndicatorModule {
}
